module.exports = __webpack_public_path__ + "static/Ciutadella-Medium-9fb0515b64dfae626b84c935de89aea5.woff2";